export type AbhaHeroResponsiveStepPayload<T extends Record<string, unknown>> = {
  mobileData?: Partial<T>
  desktopData?: Partial<T>
} & Partial<T>

export const resolveAbhaHeroStepData = <T extends Record<string, unknown>>(
  data: AbhaHeroResponsiveStepPayload<T> | undefined,
  isMobile: boolean,
  defaults: T
): T => {
  if (!data) {
    return defaults
  }

  const { mobileData, desktopData, ...shared } = data
  const platformData = isMobile ? mobileData : desktopData

  return {
    ...defaults,
    ...shared,
    ...platformData,
  }
}

export const formatAbhaHeroStepTemplate = (template: string, variables: Record<string, string | undefined>): string =>
  Object.entries(variables).reduce((result, [key, value]) => {
    if (!value) return result

    return result.split(`{{${key}}}`).join(value)
  }, template)
